var map = {
	"./ch_CH.png": 38662,
	"./ch_CHS.png": 56568,
	"./ch_TW.png": 88317,
	"./de_DE.png": 28286,
	"./en_AU.png": 61013,
	"./en_CA.png": 44909,
	"./en_MY.png": 92102,
	"./en_SG.png": 87906,
	"./en_UK.png": 93926,
	"./en_US.png": 55542,
	"./es_ES.png": 15408,
	"./fr_CA.png": 4439,
	"./fr_FR.png": 98187,
	"./jp_JP.png": 55409,
	"./kr_KR.png": 26531,
	"./ru_RU.png": 45645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87537;